import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";

export default function PostCategories() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null); // {post_categories: [{name, personnel_categories}]}
  const [personnelCategories, setPersonnelCategories] = useState([]);
  const [msg, setMsg] = useState({ text: "", type: "info" });

  useEffect(() => {
    Promise.all([api.get("/stat-functii/config"), api.get("/config")]).then(([sf, c]) => {
      setCfg(sf.data);
      setPersonnelCategories(c.data.personnel_categories || []);
    });
  }, []);

  const save = async () => {
    try {
      await api.put("/stat-functii/config", cfg);
      setMsg({ text: "Salvat", type: "success" }); setTimeout(() => setMsg({ text: "" }), 1500);
    } catch (e) { setMsg({ text: e?.response?.data?.detail || "Eroare", type: "error" }); }
  };
  if (!cfg) return <div>Se încarcă...</div>;

  const cats = cfg.post_categories || [];
  const updName = (i, name) => { const a = [...cats]; a[i] = { ...a[i], name }; setCfg({ ...cfg, post_categories: a }); };
  const togglePersonnel = (i, pc) => {
    const a = [...cats];
    const current = a[i].personnel_categories || [];
    a[i] = { ...a[i], personnel_categories: current.includes(pc) ? current.filter(x => x !== pc) : [...current, pc] };
    setCfg({ ...cfg, post_categories: a });
  };
  const add = () => setCfg({ ...cfg, post_categories: [...cats, { name: "Categorie nouă", personnel_categories: [] }] });
  const rm = (i) => { const a = [...cats]; a.splice(i, 1); setCfg({ ...cfg, post_categories: a }); };

  return (
    <>
      <PageHeader title="Categorii de post" subtitle="Folosite la Stat de funcții"
        actions={<button className="btn btn-primary" onClick={save} data-testid="save-post-categories" {...lock(has("stat_functii.categories_manage"))}>Salvează</button>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 24 }}>
        <div style={{ fontSize: 12, color: "#64748B", marginBottom: 14 }}>
          Fiecare categorie de post poate avea una sau mai multe categorii de personal alocate — la crearea unui post cu
          această categorie, dropdown-ul „Categorie personal" se restrânge doar la cele bifate aici. O categorie fără
          nimic bifat rămâne nerestricționată.
        </div>
        <div style={{ display: "grid", gap: 14 }}>
          {cats.map((c, i) => (
            <div key={i} style={{ border: "1px solid #E2E8F0", borderRadius: 8, padding: 12 }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                <input className="input" value={c.name} onChange={e => updName(i, e.target.value)} />
                <button className="btn btn-danger" style={{ padding: "4px 10px", fontSize: 12 }} onClick={() => rm(i)}>Șterge</button>
              </div>
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                {personnelCategories.map(pc => (
                  <label key={pc} style={{ fontSize: 12, display: "flex", gap: 5, alignItems: "center" }}>
                    <input type="checkbox" checked={(c.personnel_categories || []).includes(pc)} onChange={() => togglePersonnel(i, pc)} />
                    {pc}
                  </label>
                ))}
                {personnelCategories.length === 0 && (
                  <span style={{ fontSize: 12, color: "#94A3B8" }}>Nicio categorie de personal definită — vezi Platform Core &gt; Categorii de personal.</span>
                )}
              </div>
            </div>
          ))}
          <button className="btn btn-secondary" onClick={add}>+ Adaugă categorie</button>
        </div>
      </div>
    </>
  );
}
